import axios from '@/lib/axios/axios';

// import { MSW_URL } from '../../config/config';

export default {
    /**
     * Creates a new address scoped to the patient.
     * @param {object} postData - A new address object.
     */
    createAddress: async (postData) => axios.post('/addresses', postData),

    /**
     * A get request to the addresses endpoint will return a paginated list of all addresses in the system,
     * scoped to patient. This request can be filtered by default state.
     */
    getAllAddresses: async () => axios.get('/addresses'),

    /**
     * Updates a specif address by uuid.
     * @param {string || number} uuid - The ID of the address to update.
     * @param {object} patchData - Address object containing the changes.
     */
    updateAddress: async (uuid, patchData) => axios.patch(`/addresses/${uuid}`, patchData),

    /**
     * Update the provided UUID to be the default address.
     * @param {string || number} uuid - The ID of the address to update.
     */
    setDefaultAddress: async (uuid) => axios.patch(`/addresses/${uuid}/make-default`),

    /**
     * Delete the specified address.
     * @param {string || number} uuid - The ID of the address to delete.
     */
    deleteAddress: async (uuid) => axios.delete(`/addresses/${uuid}`),
};
